import _ from 'lodash'
import React from 'react'
import * as apiActions from 'actions/apiActions'
import Store from '../../../../../store.js'
import DropdownMenu from 'GeneralUI/DropdownMenu/DropdownMenu.jsx'

class BaseObject {
  static _propConfigs = []
  constructor(row = {}) {
    this._propConfigs.forEach((propConfig, index) => {
      if (propConfig.relation_class === null) {
        propConfig
          .relation_class_loader()
          .then(
            relationClass =>
              (this._propConfigs[index].relation_class = relationClass.default)
          )
      }
    })
  }
  get _propConfigs() {
    return this.constructor._propConfigs
  }
  get _objectType() {
    return this.constructor._objectType
  }
  get _apiBaseRoute() {
    return this.constructor._apiBaseRoute
  }
  get _primaryKey() {
    return this.constructor._primaryKey
  }
  get _isExportable() {
    return this.constructor._isExportable
  }
  get _isMapable() {
    return this.constructor._isMapable
  }
  mapped_id = null // -1 indicates it will be created during import, null indicates a selection is required.
  prefix = ''
  _representsRows = []
  static _objectType = null
  static _apiBaseRoute = null
  static _primaryKey = null
  static _isMapable = true
  static _isExportable = null
  static _relationTypes = {
    hasOne: 'hasOne',
    hasMany: 'hasMany'
  }
  hasManyPostfix = null // in to postfix to hasMany props like thing_id_1 thing_id_2
  get requiresImport() {
    return this.mapped_id === -1
  }
  _preformDataCast = (value, dataType) => {
    if (dataType != null) {
      switch (dataType.toLowerCase()) {
        case 'boolean':
        case 'bool':
          if (typeof value !== 'string') {
            return value
          } else if (value.toLowerCase() === 'true') {
            return true
          } else if (value.toLowerCase() === 'false') {
            return false
          } else {
            return value
          }
        case 'integer':
          return parseInt(value)
        default:
          // special null handling
          if (typeof value === 'string' && value.toLowerCase() === 'null') {
            return null
          } else {
            return value
          }
      }
    } else {
      return value
    }
  }
  _addPropIfExists = (propConfig, row) => {
    let rowName
    const postfix = this.hasManyPostfix == null ? '' : `_${this.hasManyPostfix}`
    rowName = this.prefix + propConfig.property_name + postfix

    if (
      row[rowName] !== undefined &&
      (propConfig.relation_type === BaseObject._relationTypes.hasOne ||
        propConfig.relation_type === BaseObject._relationTypes.hasMany) &&
      (row[rowName] !== '' || propConfig.allowEmptyString === true)
    ) {
      this[propConfig.property_name] = row[rowName]
    } else if (
      row[rowName] !== undefined &&
      propConfig.relation_type == null &&
      (row[rowName] !== '' || propConfig.allowEmptyString === true)
    ) {
      const rawData =
        propConfig.mutator != null
          ? propConfig.mutator(row[rowName])
          : row[rowName]
      this[propConfig.property_name] = this._preformDataCast(
        rawData,
        propConfig.data_type
      )
    } else if (propConfig.default !== undefined) {
      this[propConfig.property_name] = propConfig.default
    }
  }
  getTableConfig = (
    existingOptions,
    allowImport,
    menuChange,
    parentRow = null
  ) => {
    const columns = this._propConfigs
      .filter(prop => prop.relation_type == null)
      .map(prop => {
        return {
          header: prop.property_name,
          id: prop.property_name,
          accessorFn: d => {
            if (prop.data_type && prop.data_type === 'boolean') {
              return _.get(d, prop.property_name) ? 'True' : 'False'
            } else {
              return _.get(d, prop.property_name)
            }
          },
          show: prop.property_name !== this._primaryKey
        }
      })
    if (this._isMapable) {
      columns.push({
        header: 'Map to existing',
        id: 'map_to_id',
        size: 250,
        cell: props => {
          const dropdownOptions = [
            ...existingOptions
              .filter(option => {
                if (
                  parentRow == null ||
                  option[parentRow.row.original._objectType] == null
                ) {
                  return true
                } else if (
                  Array.isArray(option[parentRow.row.original._objectType])
                ) {
                  // this is a sub menu so it should filter the list to only include options
                  // related to the parentItem
                  return option[parentRow.row.original._objectType].some(
                    parentRelation =>
                      parentRelation[parentRow.row.original._primaryKey] ===
                      parentRow.row.original.mapped_id
                  )
                } else {
                  return (
                    option[parentRow.row.original._objectType][
                      parentRow.row.original._primaryKey
                    ] === parentRow.row.original.mapped_id
                  )
                }
              })
              .map(item => {
                return {
                  value: item[item._primaryKey],
                  name: item.optionName
                }
              })
          ]
          if (allowImport) {
            dropdownOptions.push({ name: 'flag for import', value: -1 })
          }
          dropdownOptions.push({ name: 'skip import', value: -2 })
          dropdownOptions.push({ name: 'not selected', value: null })
          return (
            <DropdownMenu
              onChange={value => menuChange(props, value)}
              value={props.row.original.mapped_id}
              options={dropdownOptions}
            />
          )
        }
      })
    }
    return columns
  }
  getSubTableConfig = (existingOptions, allowImport, menuChange) => null
  static getDataFromResponse(response) {
    return response.data.data[this._apiBaseRoute]
  }
  flagForImport = () => {
    // this returns -1 to flag the item for import but can be overridden (inventory) if a test needs to be run
    // to determine if a specific instance of an item is importable (inventory cant import ent_dilutions for example.)
    return -1
  }
  importDetails = Item => {
    // for any properties in (clean)item that dont exist in this... import them
    Object.keys(Item._clean()).forEach(prop => {
      if (this[prop] === undefined) {
        this[prop] = Item[prop]
      }
    })
  }
  isEmpty = () => {
    // use to determine if no properties at all were found.
    return this._propConfigs.every(
      propConfig => this[propConfig.property_name] == null
    )
  }
  validate = () => {
    const errors = []
    this._propConfigs.forEach(propConfig => {
      // if the local value hasn't been set and it has a validation rule
      if (propConfig.validate) {
        if (Array.isArray(propConfig.validate)) {
          propConfig.validate.forEach(rule => {
            const error = this.subValidate(rule, propConfig)
            if (error != null) {
              errors.push(error)
            }
          })
        } else {
          const error = this.subValidate(propConfig.validate, propConfig)
          if (error != null) {
            errors.push(error)
          }
        }
      }
    })
    return errors
  }
  subValidate = (validation, propConfig) => {
    const requiredName = propConfig.property_name
    const postfix = this.hasManyPostfix == null ? '' : `_${this.hasManyPostfix}`
    // if its a required rule
    if (
      validation === 'integer' &&
      this[propConfig.property_name] !== undefined &&
      isNaN(this[propConfig.property_name])
    ) {
      return `The ${requiredName}${postfix} property must be numeric.`
    } else if (
      validation === 'required' &&
      this[propConfig.property_name] === undefined &&
      propConfig.relation_type == null // this is required or all rows will fail required relations at the
      // base level even if all required subrows of the relation are present. I feel like there is another
      // case where this needs to be removed for something else to work but I cant remember what it is. If
      // debugging some other case... you will have to find a way to satisfy both cases. Without this, we
      // wont get past the initial CSV validation prior to mapping.
    ) {
      // throw required error
      return `A ${this._objectType} requires a ${requiredName}${postfix} property`
    } else if (this[propConfig.property_name] === undefined) {
      const rule = validation.split(':')
      // if its required without
      if (rule[0] === 'requiredWithout') {
        // find the without object based on the property_name
        try {
          const found = this._propConfigs.find(
            prop => prop.property_name === rule[1]
          )
          // if the xtract name associated with that thing isnt set
          if (!this[found.property_name]) {
            // throw required without error.
            return `A ${this._objectType} requires a ${requiredName}${postfix} or a ${found.property_name}${postfix} property`
          }
        } catch (e) {
          throw new Error(
            'invalid requiredWithout reference :' +
              rule[1] +
              " doesn't exist on " +
              this._objectType
          )
        }
      }
    }
  }
  isEquivalent = item => {
    return (
      this.name &&
      item.name &&
      this.name.toLowerCase() === item.name.toLowerCase()
    )
  }
  get optionName() {
    return `${this[this._primaryKey]}: ${this.name}`
  }
  representsRow = idx => {
    return this._representsRows.indexOf(idx) !== -1
  }
  ignoreRow = idx => {
    this._representsRows = this._representsRows.filter(row => row !== idx)
  }
  // accepts a list of all items of a type (example extract)that have been
  // pulled from the data and checks if they are related to this item (example
  // product) by seeing if they share a row in _representsRows
  updateRelation = function(list, currentRowNum) {
    if (!Array.isArray(list) || list.length < 1) {
      // there may not be any existing items of this relation type
      // to update yet
      return
    }
    // see if the items in the list represent a valid relation
    const relation = this._propConfigs.find(nameObj => {
      // if (nameObj.relation_class === null) {
      //   nameObj.relation_class = nameObj.relation_class_loader()
      // }
      return (
        nameObj.relation_class != null &&
        list[0] != null &&
        nameObj.relation_class._objectType === list[0]._objectType &&
        nameObj.relation_type != null
      )
    })

    // looks valid so continue
    if (relation != null) {
      // update this objects relations
      const relations = [...this._representsRows, currentRowNum].reduce(
        (relations, rowNum) => {
          const found = list.filter(existingObj =>
            existingObj.representsRow(rowNum)
          )
          return [...relations, ...found]
        },
        []
      )

      const distinctRelations = this._distinctRelations(relations)

      // set the actual related js object as a relation on this js object.
      this[relation.property_name] =
        relation.relation_type === BaseObject._relationTypes.hasMany
          ? distinctRelations
          : distinctRelations[0]

      // for each of the relations, we need to add this to the related items
      // relations so it can be accessed in the other direction.
      distinctRelations.forEach(relatedObject => {
        const relatedRelations = [
          ...(relatedObject[this._objectType] || []),
          this
        ]
        const relatedDistinctRelations =
          this._distinctRelations(relatedRelations)
        const relatedRelation = relatedObject._propConfigs.find(prop => {
          // if (prop.relation_class === null) {
          //   prop.relation_class = prop.relation_class_loader()
          // }
          return (
            prop.relation_class &&
            prop.relation_class._objectType === this._objectType
          )
        })
        if (relatedRelation) {
          relatedObject[relatedRelation.relation_class._objectType] =
            relatedRelation.relation_type === BaseObject._relationTypes.hasMany
              ? relatedDistinctRelations
              : relatedDistinctRelations[0]
        }
      })
    }
  }
  _distinctRelations = (relations = []) => {
    const distinctRelations = []
    relations.forEach(relation => {
      if (
        !distinctRelations.some(accepted => {
          // we only keep one relation for each mapped id except for mapped_id -1 which
          // means we are importing... we could have several distinct importing objects
          // so in that case we only keep one "equivilant" importing object.
          return (
            relation.isEquivalent(accepted) ||
            (accepted.mapped_id !== -1 &&
              accepted.mapped_id === relation.mapped_id)
          )
        })
      ) {
        distinctRelations.push(relation)
      }
    })
    return distinctRelations
  }
  mergeSelfIntoList = (List, RowIdx) => {
    this._representsRows.push(RowIdx)
    // newCleanItem will have only the properties matching the _propConfig.property_names defined in its class
    // note that the newCleanItem is only used to check for equivalence but the original "unclean" item including
    // mapped_id is what is actually merged into the list.
    const newCleanItem = this._clean()
    if (List == null || List.length === 0) {
      // start a new list if it was empty
      return [this]
    }
    let match
    for (let idx = 0; idx < List.length; idx++) {
      const item = List[idx]._clean()
      if (_.isEqual(item, newCleanItem)) {
        // found it, no need to continue
        // but we need to add the current row to the existing items
        // represented rows.
        List[idx]._representsRows.push(RowIdx)
        match = true
        break
      } else {
        // see if all the properties they both have match
        const itemKeys = Object.keys(item)
        const thisKeys = Object.keys(newCleanItem)
        const sharedKeys = _.intersection(itemKeys, thisKeys)
        match = sharedKeys.every(key => newCleanItem[key] == item[key])

        if (
          match &&
          Object.keys(item).length <= Object.keys(newCleanItem).length
        ) {
          // they match but this(item to add) has extra properties so update item to include them
          List[idx].importDetails(this)
          // and add the index to the represented rows
          List[idx]._representsRows.push(RowIdx)
          break
        } else if (
          match &&
          Object.keys(item).length > Object.keys(newCleanItem).length
        ) {
          // they match but item was more specific... that is fine...
          // just add the new index tot he represented rows
          List[idx]._representsRows.push(RowIdx)
          break
        }
      }
    }
    if (!match) {
      // no match so push it
      List.push(this)
    }

    return List
  }
  get isMapped() {
    return this.mapped_id != null
  }
  _clean = () => {
    // returns only properties included in the propConfigs array as an property_name
    return _.pick(
      this,
      this._propConfigs.map(propConfig => propConfig.property_name)
    )
  }
  asyncForEach = async(array, callback) => {
    if (Array.isArray(array)) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }
  }
  buildImportableItem = () => {
    return this._clean()
  }

  get importableItem() {
    if (this.mapped_id !== -1) {
      const obj = this.buildImportableItem()
      obj[this._primaryKey] = this.mapped_id
      return obj
    } else {
      return this.buildImportableItem()
    }
  }
  clone = () => {
    const newItem = new this.constructor(this)
    // this is heavy handed to copy every prop when a bunch of them will
    // be the function in this baseObject. Sometime I should skip copying those
    // in the loop below but this is a quick and dirty fix for cloning to appease
    // XtractTable
    for (const prop in this) {
      newItem[prop] = this[prop]
    }
    return newItem
  }
  static apiReadAll(callbacks = {}) {
    const action = apiActions.xtractAPI(
      this._apiBaseRoute,
      'READ_ALL',
      null,
      callbacks
    )
    Store.dispatch(action)
  }
  apiCreate = (callbacks = {}) => {
    Store.dispatch(
      apiActions.xtractAPI(
        this._apiBaseRoute,
        'create',
        this.importableItem,
        callbacks
      )
    )
  }
  apiUpdate = (callbacks = {}) => {
    Store.dispatch(
      apiActions.xtractAPI(
        `${this._apiBaseRoute}/${this.mapped_id}`,
        'update',
        this.importableItem,
        callbacks
      )
    )
  }
  apiDelete = (callbacks = {}) => {
    Store.dispatch(
      apiActions.xtractAPI(
        `${this._apiBaseRoute}${this.mapped_id}`,
        'delete',
        null,
        callbacks
      )
    )
  }
  apiDownloadExport = (callbacks = {}) => {
    if (this._isExportable) {
      Store.dispatch(
        apiActions.fileDownload(
          `${this._apiBaseRoute}`,
          `Summit_${this._objectType}_export.csv`,
          callbacks,
          {
            contentType: 'text/csv'
          }
        )
      )
    }
  }
  updatePropsFromApi = response => {
    const apiObject = (this.constructor).getDataFromResponse(response)
    if (this._isMapable) {
      this.mapped_id = apiObject[this._primaryKey]
    }
    this._propConfigs.forEach(propConfig => {
      this._addPropIfExists(propConfig, apiObject)
    })
  }
  apiRefresh = (callbacks = {}) => {
    const wrappedCallbacks = {
      ...callbacks,
      200: (response, action, defaultCallback) => {
        this.updatePropsFromApi(response)
        if (callbacks[200]) {
          callbacks[200](response, action, defaultCallback)
        }
      }
    }
    Store.dispatch(
      apiActions.xtractAPI(
        `${this._apiBaseRoute}/${this._primaryKey}`,
        'read',
        null,
        wrappedCallbacks
      )
    )
  }
}

export default BaseObject
